import { useCallback, useMemo } from 'react';
import type { SaveData } from '../types/save';
import { logger } from '../lib/terminalLogger';

export type ValidationIssue = {
  code: string;
  message: string;
  severity?: 'info' | 'warning' | 'error';
};

export type ValidationContext = {
  allChecked?: boolean;
};

export function useValidation() {
  const validateBeforeSave = useCallback(
    (data?: SaveData, ctx?: ValidationContext) => {
      const issues: ValidationIssue[] = [];

      // Regra 1: orc_id presente
      if (!data?.pedido?.orc_id) {
        issues.push({
          code: 'MISSING_ORC_ID',
          message: 'Número de pedido (orc_id) ausente.',
          severity: 'error',
        });
      } else {
        // Regra 2: orc_id numérico
        const raw = String(data.pedido.orc_id);
        if (!/^\d+$/.test(raw)) {
          issues.push({
            code: 'INVALID_ORC_ID_FORMAT',
            message: `Formato inválido para orc_id: "${raw}". Deve conter apenas números.`,
            severity: 'error',
          });
        }
      }

      // Regra 3: checklist completo (bloqueante aqui)
      if (ctx?.allChecked === false) {
        issues.push({
          code: 'CHECKLIST_NOT_COMPLETE',
          message: 'Checklist não está completamente marcado.',
          severity: 'error',
        });
      }

      if (issues.length > 0) {
        logger.debug('[useValidation] Issues detectadas:', issues);
      }

      const hasBlockingError = issues.some(i => i.severity === 'error');
      return {
        valid: !hasBlockingError,
        issues,
      } as const;
    },
    []
  );

  return useMemo(
    () => ({
      validateBeforeSave,
    }),
    [validateBeforeSave]
  );
}